(function() {
  var timer = null;

  function clearPulseReload() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function schedulePulseReload() {
    clearPulseReload();
    if (!document.querySelector(".pulse-page")) return;

    timer = setTimeout(function() {
      timer = null;
      if (!document.querySelector(".pulse-page")) return;

      if (window.Turbolinks) {
        Turbolinks.visit(window.location.href, { action: "replace" });
      } else {
        window.location.reload();
      }
    }, 12000);
  }

  document.addEventListener("turbolinks:load", schedulePulseReload);
  document.addEventListener("turbolinks:before-visit", clearPulseReload);
  document.addEventListener("turbolinks:before-cache", clearPulseReload);
})();
